import { LitElement, html, utils, css } from '@hh/global.js'
const {
  getCookie,
  setCookie,
  addToCart,
  reRenderShopifySections
} = utils

class HHCartUpsellItem extends LitElement {
  static properties = {
    productId: {
      type: Number,
      attribute: 'product-id'
    },
    variantId: {
      type: Number,
      attribute: 'variant-id'
    },
    variantProperties: {
      type: Object,
      attribute: 'variant-properties'
    },
    hidden: {
      type: Boolean,
      reflect: true
    },
    loading: {
      type: Boolean,
      reflect: true
    }
  }

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()

    const removedItems = (getCookie('removed-upsells') || '').split(',')
    this.hidden = removedItems.includes(`${this.productId}`)
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  async onAdd() {
    this.loading = true

    const result = await addToCart(
      {
        items: [
          {
            id: this.variantId,
            properties: this.variantProperties
          }
        ],
      },
      'mini-cart,header'
    )

    const item = result.items.find(item => item.variant_id === this.variantId)

    window.dataLayer.push({ event: 'cross-sell-added', item })

    reRenderShopifySections(
      result
    )
  }

  onRemove() {
    let removedItems = (getCookie('removed-upsells') || '').split(',')
    removedItems = [...removedItems, this.productId].join(',')
    setCookie('removed-upsells', removedItems)

    this.hidden = true
  }

  render() {
    return html`<slot
      @addUpsell="${this.onAdd}"
      @removeUpsell="${this.onRemove}"
    ></slot>`
  }

  static styles = css`
    :host([loading]) {
      pointer-events: none;
      opacity: 0.8;
    }
  `
}

customElements.define('hh-cart-upsell-item', HHCartUpsellItem)
